import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
//import $ from "jquery";
//import ScrollContainer from 'react-indiana-drag-scroll'
import reduxHelper from "./../../../helper/index.js";
import moment from "moment";
//import ApexCharts from 'apexcharts';
//import Chart from 'react-apexcharts';
import { ClipLoader } from 'react-spinners';
import api from "./../../../Api.js";

// reactstrap components
import {
  Container,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap";
import Mystudents from "./../widget/Mystudents.jsx";

class Teacher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classRooms: [],
      myStudents: [],
      classroomusers: [],
      classRoomProgress: [],
      loadClassRoom: false,
      loadMyStudents: false,
      tasksCount: 0,
      tasksToCorrectCount: 0,
      tasksPerClass: [],            
      loadTasksCount: false,
      loadTasksToCorrect: false,
      // controla o modal de usuário
      showUserModal: false,
      modalUser: null,
     // filtro: mostrar apenas turmas ativas (não fechadas)
     showOnlyActive: false,
    // filters for the teacher dropdown
    filterName: '',
    filterCourse: '',
    filterStartDate: '',
    filterEndDate: '',
    filterStatus: 'all', // values: all, active, closed
    showFiltersDropdown: false
    };

    this.helper = new reduxHelper(this.props);
    this.getMyStudents = this.getMyStudents.bind(this);
    this.getUsersClassRoom = this.getUsersClassRoom.bind(this);
    this.getProgressClassRoom = this.getProgressClassRoom.bind(this);
    this.getTasksData = this.getTasksData.bind(this);
    this.openUserModal = this.openUserModal.bind(this);
    this.closeUserModal = this.closeUserModal.bind(this);
    this.toggleShowOnlyActive = this.toggleShowOnlyActive.bind(this);
  this.handleFilterChange = this.handleFilterChange.bind(this);
  this.handleCourseFilterChange = this.handleCourseFilterChange.bind(this);
  this.handleFilterDateChange = this.handleFilterDateChange.bind(this);
  this.clearFilters = this.clearFilters.bind(this);
  this.toggleFiltersDropdown = this.toggleFiltersDropdown.bind(this);

    window.teacher_dashboard = this;
  }

  // Pega os alunos que eu tenho acesso
  async getMyStudents() {
    var students = await this.helper.widget().getMyStudents();
    if (students.status === 200) {
      this.setState({ myStudents: students.data, loadMyStudents: true });
    }
  }

  // Para pegar o progresso completo da turma
  async getProgressClassRoom(classroom) {
    await api.getProgressAllUnits(classroom).then(async (res) => {
      var classRoomProgress = this.state.classRoomProgress;
      classRoomProgress.push({ classroom: classroom, progress: res.data.progressClassRoom });
      await this.setState({ classRoomProgress: classRoomProgress });
    }).catch(error => {
      console.log(error);
      return false;
    });
  }

  // Pega as turmas que eu participo
  async getMyClassRooms() {
    var classrooms = await this.helper.classroom().getMyClassRooms(this.props.user.id);
    if (classrooms.status === 200) {
      await this.setState({ classRooms: classrooms.data, loadClassRoom: true });
      for (let index = 0; index < classrooms.data.length; index++) {
        await this.getUsersClassRoom(classrooms.data[index].id);
        await this.getProgressClassRoom(classrooms.data[index].id);
      }
      this.getTasksData();
    }
  }

  // Para pesquisar quais alunos estão nessa turma
  async getUsersClassRoom(id) {
    var a = await api.searchUserClassRoom(id).then((res) => {
      var classRooms = this.state.classRooms;
      var index = classRooms.map(function (x) { return x.id; }).indexOf(id);
      classRooms[index].students = res.data;
      this.setState({ classRooms: classRooms });
      return true;
    }).catch(error => {
      console.log(error);
      return false;
    });
    return a;
  }

  async getTasksData() {
    const { classRooms } = this.state;
    let totalTasks = 0;
    let totalPendentes = 0;
    let tasksPerClass = []; 

    this.setState({ loadTasksCount: false, loadTasksToCorrect: false });

    for (let turma of classRooms) {
      try {
        const respTasks = await api.getTasksClassroom(turma.id);
        const tasks = respTasks.data || [];
        totalTasks += tasks.length;

        // Contar pendentes (points === null) nesta turma
        let pendentesCount = 0;
        for (let t of tasks) {
          const respSubs = await api.getTaskSubmissionsWithDetails(t.id);
          const subs = respSubs.data || [];
          const pendentes = subs.filter(s => s.points === null);
          pendentesCount += pendentes.length;
        }
        totalPendentes += pendentesCount;
        tasksPerClass.push({ name: turma.name, count: pendentesCount });
      } catch (err) {
        console.error("Erro ao buscar tasks/submissions da turma " + turma.id, err);
      }
    }

    this.setState({
      tasksCount: totalTasks,
      tasksToCorrectCount: totalPendentes,
      tasksPerClass: tasksPerClass,       // salva o array no estado
      loadTasksCount: true,
      loadTasksToCorrect: true
    });
  }

  async componentDidMount() {
    this.getMyStudents();
    this.getMyClassRooms();
  }

  componentWillUnmount() { }

  // Para pegar a diferença de dias e calcular progresso
  calcProgressClassRoom(openingDate, closingDate) {
    closingDate = moment(closingDate, "YYYY-MM-DD");
    openingDate = moment(openingDate, "YYYY-MM-DD");

    var hoje = moment().format("YYYY-MM-DD");
    var diferencaDiasTurma = closingDate.diff(openingDate, 'days');
    var diferencaDiasHoje = closingDate.diff(hoje, 'days');
    var resultado = ((diferencaDiasTurma - diferencaDiasHoje) * 100) / diferencaDiasTurma;

    if (diferencaDiasTurma <= diferencaDiasHoje) { resultado = 0; }
    if (resultado === Infinity) { resultado = 0; }

    return resultado.toFixed(0);
  }

  // Abre o modal com as informações do usuário clicado
  openUserModal(user) {
    this.setState({ showUserModal: true, modalUser: user });
  }

  // Fecha o modal
  closeUserModal() {
    this.setState({ showUserModal: false, modalUser: null });
  }

  toggleShowOnlyActive(e) {
    this.setState({ showOnlyActive: e.target.checked });
  }

  handleFilterChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleCourseFilterChange(e) {
    // course selects may provide numeric id or empty
    this.setState({ filterCourse: e.target.value });
  }

  handleFilterDateChange(name, value) {
    // expects YYYY-MM-DD strings or empty
    this.setState({ [name]: value });
  }

  clearFilters() {
    this.setState({ filterName: '', filterCourse: '', filterStartDate: '', filterEndDate: '', filterStatus: 'all' });
  }

  toggleFiltersDropdown() {
    this.setState({ showFiltersDropdown: !this.state.showFiltersDropdown });
  }

  render() {
    const { showUserModal, modalUser, classRooms, showOnlyActive } = this.state;

    // apply both the quick "only active" and the advanced filters
    let visibleClassRooms = classRooms.slice();

    // quick toggle for only active
    if (showOnlyActive) {
      visibleClassRooms = visibleClassRooms.filter(c => !moment().isAfter(moment(c.closingDate, 'YYYY-MM-DD'), 'day'));
    }

    // advanced filters (dropdown)
    const { filterName, filterCourse, filterStartDate, filterEndDate, filterStatus } = this.state;

    if (filterName && filterName.trim() !== '') {
      const q = filterName.toLowerCase();
      visibleClassRooms = visibleClassRooms.filter(c => (c.name || '').toLowerCase().indexOf(q) !== -1);
    }

    if (filterCourse && filterCourse !== '') {
      visibleClassRooms = visibleClassRooms.filter(c => String(c.course) === String(filterCourse));
    }

    if (filterStartDate) {
      visibleClassRooms = visibleClassRooms.filter(c => {
        return moment(c.openingDate, 'YYYY-MM-DD').isSameOrAfter(moment(filterStartDate, 'YYYY-MM-DD'));
      });
    }

    if (filterEndDate) {
      visibleClassRooms = visibleClassRooms.filter(c => {
        return moment(c.closingDate, 'YYYY-MM-DD').isSameOrBefore(moment(filterEndDate, 'YYYY-MM-DD'));
      });
    }

    if (filterStatus && filterStatus !== 'all') {
      if (filterStatus === 'active') {
        visibleClassRooms = visibleClassRooms.filter(c => !moment().isAfter(moment(c.closingDate, 'YYYY-MM-DD'), 'day'));
      } else if (filterStatus === 'closed') {
        visibleClassRooms = visibleClassRooms.filter(c => moment().isAfter(moment(c.closingDate, 'YYYY-MM-DD'), 'day'));
      }
    }

    const allCourses = this.props.getMainState ? (this.props.getMainState().courses || []) : [];
    const teacherCourseIds = Array.from(new Set(classRooms.map(c => c.course).filter(id => id !== undefined && id !== null && id !== '')));
    const teacherCourses = teacherCourseIds.map(id => {
      return (this.props.getCourseState ? this.props.getCourseState(id) : allCourses.find(x => String(x.id) === String(id)));
    }).filter(c => c).sort((a, b) => (a.name || '').localeCompare(b.name));

    let classesOfUser = [];
    if(modalUser){
        classesOfUser = classRooms
            .filter(c => c.students && c.students.some(s => s.id === modalUser.id))
            .map(c => c.name);
    }
    // Prepara texto para o tooltip de pendentes por turma
    const tooltipText = this.state.tasksPerClass
      .map(t => `${t.name}: ${t.count}`)
      .join(", ");

    return (
      <>
        <style>
          {`
            .navbar-top { background:#0000 !important; }
            .navbar-top { position: absolute; width: 100%; z-index:2; }
            /* Estilização para o item clicável de aluno */
            .student-item { cursor: pointer; }
            /* Estilo do container da foto no modal */
            .modal-photo-container { position: relative; display: flex; justify-content: center}
            .modal-user-photo { width: 100px; height: 100px; border-radius: 50%;  }
            /* Status dot no canto da foto */
            .status-dot {
              position: absolute;
              top: 80px;
              left: 41%;
              right: 50%;
              width: 15px;
              height: 15px;
              border-radius: 50%;
              border: 2px solid white;
            }
            /* Container de informações no modal */
            .modal-user-info { text-align: center; margin-top: 10px; }
            .modal-user-info h4 { margin-bottom: 8px; }
            .modal-user-info small { color: #6c757d; }
            .modal-user-info .info-row { margin: 5px 0; }
          `}
        </style>

        <div className="header d-flex align-items-center"
          style={{
            minHeight: "200px",
            backgroundImage: 'url("/images/background.jpg")',
            backgroundSize: "cover"
          }}>
          <span className="mask opacity-8"
            style={{
              background: 'linear-gradient(-45deg,' +
                window.app.state.confs.headerDegrade1 + ',' +
                window.app.state.confs.headerDegrade2 + ')'
            }} />
          <Container className="d-flex align-items-center" fluid>
          </Container>
        </div>

        <Container className="mt--6" fluid>
          <div className="row">
            <div className="col-md-6 col-xl-3">
              <Mystudents users={this.state.myStudents} load={this.state.loadMyStudents} />
            </div>
            <div className="col-md-6 col-xl-3">
              <div className="card-stats card">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <h5 className="text-uppercase text-muted mb-0 card-title">{this.props.translate['minhas_turmas']}</h5>
                      <span className="h2 font-weight-bold mb-0">
                        {
                          !this.state.loadClassRoom &&
                          <font><ClipLoader sizeUnit={"px"} size={20} color={'#adb5bd'} loading={true} /></font>
                        }
                        {
                          this.state.loadClassRoom &&
                          <React.Fragment><font className="animated fadeIn">{this.state.classRooms.length}</font></React.Fragment>
                        }
                      </span>
                    </div>
                    <div className="col-auto col">
                      <div className="icon icon-shape bg-gradient-orange text-white rounded-circle shadow">
                        <i className="fas fa-graduation-cap"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-3">
              <div className="card-stats card">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <h5 className="text-uppercase text-muted mb-0 card-title">Atividades agendadas</h5>
                      <span className="h2 font-weight-bold mb-0">
                        {
                          !this.state.loadTasksCount &&
                          <font><ClipLoader sizeUnit={"px"} size={20} color={'#adb5bd'} loading={true} /></font>
                        }
                        {
                          this.state.loadTasksCount &&
                          <>
                             {/* Ajuste aqui, mantendo o id igual ao target do Tooltip */}
                            <font id="scheduledTasksToolTip" className="animated fadeIn">{this.state.tasksCount}</font>
                         
                            <UncontrolledTooltip delay={0} target="scheduledTasksToolTip">
                                Número de tarefas nas salas em que você está inserido como professor
                            </UncontrolledTooltip>
                          </>
                          
                           
                        }
                      </span>
                    </div>
                    <div className="col-auto col">
                      <div className="icon icon-shape bg-gradient-green text-white rounded-circle shadow">
                        <i className="fas fa-chalkboard-teacher"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 col-xl-3">
              <div className="card-stats card">
                <div className="card-body">
                  <div className="row">
                    <div className="col">
                      <h5 className="text-uppercase text-muted mb-0 card-title">
                        Tarefas para corrigir
                      </h5>
                      <span className="h2 font-weight-bold mb-0">
                        {
                          !this.state.loadTasksToCorrect &&
                          <font><ClipLoader sizeUnit={"px"} size={20} color={'#adb5bd'} loading={true} /></font>
                        }
                        {
                          this.state.loadTasksToCorrect &&
                          <>
                            <font className="animated fadeIn" id="tasksTooltip">
                              {this.state.tasksToCorrectCount}
                            </font>
                            <UncontrolledTooltip delay={0} target="tasksTooltip">
                              {tooltipText}
                            </UncontrolledTooltip>
                          </>
                        }
                      </span>
                    </div>
                    <div className="col-auto col">
                      <div className="icon icon-shape bg-gradient-primary text-white rounded-circle shadow">
                        <i className="ni ni-active-40"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xl-9">
              <div className="card">
                <div className="border-0 card-header">
                  <div className="d-flex align-items-center">
                    <h3 className="mb-0">{this.props.translate['minhas_turmas']}</h3>
                    <div className="ml-auto d-flex align-items-center" style={{ gap: 8 }}>
                      <div className="d-none d-md-block mr-2">
                        <div className="dropdown">
                          <button className="btn btn-sm btn-primary dropdown-toggle" type="button" id="teacherFiltersDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={this.toggleFiltersDropdown}>
                            <i className="fas fa-filter" /> <span className="ml-1">Filtros</span>
                          </button>
                          <div className={`dropdown-menu dropdown-menu-right p-3 ${this.state.showFiltersDropdown ? 'show' : ''}`} aria-labelledby="teacherFiltersDropdown" style={{ minWidth: 320 }}>
                            <div className="form-group mb-2">
                              <label className="form-control-label small mb-1 text-muted">Nome</label>
                              <input name="filterName" value={this.state.filterName} onChange={this.handleFilterChange} className="form-control form-control-sm" placeholder="Buscar por nome" />
                            </div>

                            <div className="form-group mb-2">
                              <label className="form-control-label small mb-1 text-muted">Curso</label>
                              <select name="filterCourse" value={this.state.filterCourse} onChange={this.handleCourseFilterChange} className="form-control form-control-sm">
                                <option value="">Todos</option>
                                {
                                  teacherCourses.map(c => (
                                    <option key={c.id} value={c.id}>{c.name}</option>
                                  ))
                                }
                              </select>
                            </div>

                            <div className="form-row">
                              <div className="form-group col-6">
                                <label className="form-control-label small mb-1 text-muted">Data Abertura</label>
                                <input type="date" name="filterStartDate" value={this.state.filterStartDate} onChange={(e) => this.handleFilterDateChange('filterStartDate', e.target.value)} className="form-control form-control-sm" />
                              </div>
                              <div className="form-group col-6">
                                <label className="form-control-label small mb-1 text-muted">Data Fechamento</label>
                                <input type="date" name="filterEndDate" value={this.state.filterEndDate} onChange={(e) => this.handleFilterDateChange('filterEndDate', e.target.value)} className="form-control form-control-sm" />
                              </div>
                            </div>

                            <div className="form-group mb-2">
                              <label className="form-control-label small mb-1 text-muted">Status</label>
                              <select name="filterStatus" value={this.state.filterStatus} onChange={this.handleFilterChange} className="form-control form-control-sm">
                                <option value="all">Todos</option>
                                <option value="active">Ativas</option>
                                <option value="closed">Encerradas</option>
                              </select>
                            </div>

                            <div className="d-flex justify-content-between mt-2">
                              <button type="button" className="btn btn-sm btn-secondary" onClick={this.clearFilters}>Limpar</button>
                              <button type="button" className="btn btn-sm btn-primary" onClick={() => this.setState({ showFiltersDropdown: false })}>Aplicar</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <table className="align-items-center table-flush table">
                    <thead className="thead-light">
                      <tr>
                        <th>{this.props.translate['nome']}</th>
                        <th>{this.props.translate['curso']}</th>
                        <th><center>{this.props.translate['data_de_fechamento']}</center></th>
                        <th><center>{this.props.translate['participantes']}</center></th>
                        <th><center>{this.props.translate['progresso']}</center></th>
                        <th>{this.props.translate['acoes']}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        visibleClassRooms.map((value) => {
                          const currentClass = this.state.classRooms.find(c => c.id === value.id) || value;
                           var course = this.props.getCourseState(value.course);
                           var img;
                           if (course.icon_file !== undefined) {
                             img = sessionStorage.getItem('centerBackend') + course.icon_file.url;
                           } else {
                             img = "";
                           }

                          if (value.inclassroom === undefined) {
                            return <React.Fragment key={value.id}></React.Fragment>
                          } else {
                            if (value.inclassroom.type === "" || value.inclassroom.type === undefined) {
                              return <React.Fragment key={value.id}></React.Fragment>;
                            }
                          }

                          var permits;
                          // pode ver todas as turmas
                          if (this.props.permission.indexOf(19) === -1) {
                            if (value.inclassroom === undefined) {
                              return <React.Fragment key={value.id}></React.Fragment>
                            } else {
                              if (value.inclassroom.type === "" || value.inclassroom.type === undefined) {
                                return <React.Fragment key={value.id}></React.Fragment>;
                              }
                            }
                            var perm = window.app.state.permitions.map(function (x) { return x.id; }).indexOf(value.inclassroom.type);
                            if (perm === -1) { return <React.Fragment key={value.id}></React.Fragment>; }
                            permits = window.app.state.permitions[perm].permissions;
                          } else {
                            permits = this.props.permission;
                          }

                          return (
                            <tr key={'arm_' + value.id}>
                              <th scope="row">
                                <div className="align-items-center media">
                                  <Link to={'/myclassroom/' + value.id} className="avatar" style={{ backgroundColor: "#fff" }}>
                                    <img style={{ backgroundColor: "#fff" }} alt="..." src={img} />
                                  </Link>
                                  <div className="media">
                                    <Link style={{ color: '#525f7f' }} to={'/myclassroom/' + value.id}>
                                      <span className="name mb-0 text-sm" style={{ marginLeft: "5px" }}>{value.name}</span>
                                    </Link>
                                  </div>
                                </div>
                              </th>
                              <td className="budget"><input value={course.name} readOnly style={{ border: 'none' }} /></td>
                              <td>
                                <center>
                                  {moment(value.closingDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                                  {
                                    (moment().isAfter(value.closingDate, 'year')) &&
                                    <React.Fragment><div style={{ color: 'red' }}>(fechada)</div></React.Fragment>
                                  }
                                </center>
                              </td>
                              <td>
                                {
                                  (currentClass.students === undefined) &&
                                  <center><ClipLoader sizeUnit={"px"} size={15} color={'#adb5bd'} loading={true} /></center>
                                }
                                {
                                  (currentClass.students !== undefined) &&
                                  <center style={{ fontWeight: '800' }} className="animated fadeIn">{currentClass.students.length}</center>
                                }
                              </td>
                              <td>
                                <center>
                                  {
                                    (this.state.classRoomProgress.map(function (x) { return x.classroom; }).indexOf(value.id) === -1) &&
                                    <ClipLoader sizeUnit={"px"} size={15} color={'#adb5bd'} loading={true} />
                                  }
                                  {
                                    (this.state.classRoomProgress.map(function (x) { return x.classroom; }).indexOf(value.id) !== -1) &&
                                    <React.Fragment>
                                      <font className="animated fadeIn">
                                        {this.state.classRoomProgress[this.state.classRoomProgress.map(function (x) { return x.classroom; }).indexOf(value.id)].progress}%
                                      </font>
                                    </React.Fragment>
                                  }
                                </center>
                              </td>
                              <td>
                                <React.Fragment>
                                  <Link to={'/myclassroom/' + value.id} id={"tt_a" + value.id} idc={value.id} className="table-action"><i className="fas fa-sign-in-alt"></i></Link>
                                  <UncontrolledTooltip delay={0} target={"tt_a" + value.id}>{this.props.translate['acessar_turma']}</UncontrolledTooltip>
                                </React.Fragment>

                                {
                                  (permits.indexOf(18) !== -1) &&
                                  <React.Fragment>
                                    <Link to={'/classroom/dashboard/' + value.id + '/none'} id={"tt_" + value.id} idc={value.id} className="table-action"><i className="fas fa-chart-pie" /></Link>
                                    <UncontrolledTooltip delay={0} target={"tt_" + value.id}>{this.props.translate['progresso_da_turma']}</UncontrolledTooltip>
                                  </React.Fragment>
                                }

                                {
                                  (value.idOnline !== "" && value.idOnline !== null) &&
                                  <React.Fragment>
                                    <a rel="noopener noreferrer" target="_blank" href={window.location.origin + '/classenter/' + value.idOnline} id={"tta_" + value.id} idc={value.id} className="table-action"><i className="fas fa-external-link-alt"></i></a>
                                    <UncontrolledTooltip delay={0} target={"tta_" + value.id}>{this.props.translate['link_acesso_online']}</UncontrolledTooltip>
                                  </React.Fragment>
                                }
                              </td>
                            </tr>
                          );
                        })
                      }
                    </tbody>
                  </table>
                  {
                    (this.state.loadClassRoom === false) &&
                    <center style={{ marginTop: '30px', marginBottom: '20px' }}><ClipLoader sizeUnit={"px"} size={30} color={'#adb5bd'} loading={true} /></center>
                  }
                  {
                    (this.state.classRooms.length === 0 && this.state.loadClassRoom === true) &&
                    <center><h3 style={{ margin: '30px 0px' }}>{this.props.translate['nenhuma_turma_foi_encontrada']}</h3></center>
                  }
                </div>
              </div>
            </div>

            <div className="col-xl-3">
              <div className="card">
                <div className="card-header">
                  <h3 className="mb-0">{this.props.translate['meus_alunos']}</h3>
                </div>
                <div className="card-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  <ul className="list my--3 list-group list-group-flush">
                    {
                      (this.state.loadMyStudents === false) &&
                      <React.Fragment>
                        <center style={{ marginTop: '10px' }}><ClipLoader sizeUnit={"px"} size={30} color={'#adb5bd'} loading={true} /></center>
                      </React.Fragment>
                    }
                    {
                      (this.state.loadMyStudents === true) &&
                      <React.Fragment>
                        {
                          this.state.myStudents.map((value, index) => {
                            var online = this.helper.chat().isOnline(this.props.useronline, value.id);
                            return (
                              <li
                                key={"teachera_" + value.id}
                                className="px-0 list-group-item student-item"
                                useridc={value.id}
                                onClick={() => this.openUserModal(value)} // Abre o modal ao clicar
                              >
                                <div className="align-items-center row">
                                  <div className="col-auto col">
                                    <font className="avatar rounded-circle">
                                      <img alt="..." src={value.photo} />
                                    </font>
                                  </div>
                                  <div className="col ml--2">
                                    <h4 className="mb-0">{value.name + ' ' + value.lastName}</h4>
                                    {
                                      (online !== false) &&
                                      <React.Fragment>
                                        <span className="text-success">●</span>
                                        <small>Online</small> <Link to={online.location}>{online.location}</Link>
                                      </React.Fragment>
                                    }
                                    {
                                      (online === false) &&
                                      <React.Fragment>
                                        <span className="text-danger">●</span>
                                        <small>Offline</small>
                                      </React.Fragment>
                                    }
                                  </div>
                                  <div className="col-auto col">
                                    <button hidden type="button" className="btn btn-primary btn-sm"><i className="far fa-comment-dots"></i> Chat</button>
                                  </div>
                                </div>
                              </li>
                            );
                          })
                        }
                      </React.Fragment>
                    }
                  </ul>
                  {
                    (this.state.myStudents.length === 0 && this.state.loadMyStudents === true) &&
                    <center><h3 style={{ margin: '30px 0px 0px 0px' }}>{this.props.translate['nenhum_usuario_foi_encontrado']}</h3></center>
                  }
                </div>
              </div>
            </div>
          </div>
        </Container>

        {/* Modal para exibir informações do usuário */}
        {modalUser && (
          <Modal isOpen={showUserModal} toggle={this.closeUserModal} centered>
            <ModalHeader toggle={this.closeUserModal}>
              {modalUser.name} {modalUser.lastName}
            </ModalHeader>
            <ModalBody>
              <div className="modal-photo-container">
                <img
                  src={modalUser.photo}
                  alt="Foto do usuário"
                  className="modal-user-photo"
                />
                {(() => {
                  const online = this.helper.chat().isOnline(this.props.useronline, modalUser.id);
                  const color = online !== false ? '#32CD32' : '#FF0000';
                  return <span className="status-dot" style={{ backgroundColor: color }} />;
                })()}
              </div>
              <div className="modal-user-info">
                <h4>{modalUser.name} {modalUser.lastName}</h4>

                {modalUser.email && (
                  <div className="info-row">
                    <small>Email: {modalUser.email}</small>
                  </div>
                )}

                {modalUser.birthDate && (
                  <div className="info-row">
                    <small>Data de Nascimento: {moment(modalUser.birthDate).format('DD/MM/YYYY')}</small>
                  </div>
                )}

                 <div className="info-row">
                <small>Turma{classesOfUser.length > 1 ? 's' : ''}:</small>
                {classesOfUser.length === 0 && (
                  <div><small> — </small></div>
                )}
                {classesOfUser.length === 1 && (
                  <div><small>{classesOfUser[0]}</small></div>
                )}
                {classesOfUser.length > 1 && (
                  <ul className="list-unstyled" style={{ marginTop: '5px', paddingLeft: '1rem' }}>
                    {classesOfUser.map((className, idx) => (
                      <li key={`class_${idx}`} style={{ lineHeight: '1.4em' }}>
                        <small>• {className}</small>
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              </div>
            </ModalBody>
          </Modal>
        )}
      </>
    );
  }
}

export default connect(state => ({
  languages: state.language,
  translate: state.translate,
  accesslevel: state.accesslevel,
  permission: state.permission,
  user: state.user,
  unit: state.unit,
  useronline: state.useronline
}))(Teacher);
